import {initSyncFormShowOrHideState} from '@/utils/formShowHideState';
import {handleFormSubmit} from '@/utils/handleFormSubmit';
import {initFloatingInputs} from '@/utils/floatingInput';
import {initRadioGroup} from '@/utils/radioButton';
import {initDatepicker} from '@/utils/datepicker';
import {initCheckBox} from '@/utils/checkBox';
import {initPaymentMethod} from '@/utils/paymentMethod';

initSyncFormShowOrHideState();
initFloatingInputs();
initRadioGroup();
initPaymentMethod();
initCheckBox();
initDatepicker();
handleFormSubmit();
